import React, { Component } from "react";
// import TagManager from 'react-gtm-module';

import Columns from "../childrens/columns/.mixins/index";
import GrupoOpcoes from "../childrens/grupoOpcoes/GrupoOpcoes";
import { Helmet } from "react-helmet";

import CustomToolbar from "../childrens/customToolbar/.mixins";

import Cookies from "universal-cookie";
import Alerta from "../../../../../util/snackbars/.mixins/";

import OpcoesRecebimentoGrupo from "../../../../../../controllers/opcoesRecebimentoGrupo";
import Config from "../../../../../../controllers/config";
import Log from "../../../../../../controllers/log";

export default class GrupoOpcoesRecebimento extends Component {
    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.state = {
            itens: [],
            itensTable: [],
            title: "Grupo Opções de Recebimento",
            columns: Columns,
            customToolbar: null,
            rowsPerPage: 7,
            pagination: true,
            isLoading: true,
            isError: false,
            error: null,
            ListaVaziaTitle: "Crie seu primeiro grupo",
            ListaVaziaText: "Adicione um novo grupo clicando em adicionar",
        };

        this.setState = this.setState.bind(this);
        this.handleAdicionar = this.handleAdicionar.bind(this);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:grupo-opcoes-recebimento',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-grupo-opcoes-recebimento',
        //     }
        // });
    }

    UNSAFE_componentWillMount() {
        //carregamento de dados nos campos
        this.loadData(this);
        this.setState({
            customToolbar: () => <CustomToolbar {...this} />,
        });
    }

    handleAdicionar() {
        this.props.router.push(`${this.props.route.path}-ae`);
    }

    async loadData(props) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            this.setState({ isLoading: true });
            const r_grupos = await OpcoesRecebimentoGrupo.getGrupos(token);
            const j_r_grupos = JSON.parse(r_grupos.body);
            const arrayItens = j_r_grupos.map((e) => {
                return { ...e };
            });
            if (r_grupos.res.statusCode == 200) {
                props.setState({
                    itensTable: arrayItens,
                    isLoading: false,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:grupo-opcoes-recebimento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:lista-opcoes-recebimento`,
                //     }
                // });
            } else {
                if (
                    j_r_grupos.status == false &&
                    j_r_grupos.message &&
                    j_r_grupos.message.includes("Token inválido!") &&
                    props.child.current != null
                ) {
                    props.child.current.retorno("Autentificação inválida!", "error");
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            //auditoria
            const str = `Efetuada requisição para recuperação de dados de grupos opções recebimento!
            Response:( Method: ${r_grupos.res.request.method}
            , StatusCode: ${r_grupos.res.statusCode}
            , Body: (limited 100chars) ${r_grupos.body.substr(0, 100)})`;
            Log.info(token, str);
        } catch (error) {
            if (props.child.current != null) {
                props.child.current.retorno(
                    "Erro ao carregar dados grupos opções recebimento!",
                    "error"
                );
            }
            let errorString = "Erro ao carregar dados grupos opções recebimento!";
            if (Config.DEBUG === "TRUE") {
                errorString = error.message;
            }
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:grupo-opcoes-recebimento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            const str = `Erro na recuperação de dados de grupos opções recebimento!
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token, str);
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} -  Grupos opções recebimento`}</title>
                </Helmet>
                <GrupoOpcoes {...this} />
                <Alerta ref={this.child} />
            </div>
        );
    }
}
